var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M92.867,220.867c-2.56,0-4.267-0.853-5.973-2.56c-3.413-3.413-2.56-8.533,0.853-11.947 l110.933-102.4c3.413-3.413,8.533-2.56,11.947,0.853c3.413,3.413,2.56,8.533-0.853,11.947L98.84,219.16 C97.133,220.013,94.573,220.867,92.867,220.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M306.2,425.667c-2.56,0-4.267-0.853-5.973-2.56c-3.413-3.413-2.56-8.533,0.853-11.947 l110.933-102.4c3.413-3.413,8.533-2.56,11.947,0.853c3.413,3.413,2.56,8.533-0.853,11.947l-110.933,102.4 C310.467,424.813,307.907,425.667,306.2,425.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M383,272.067H123.587c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533H383 c5.12,0,8.533,3.413,8.533,8.533C391.533,268.653,388.12,272.067,383,272.067z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7308"
    },
    d: "M255,7.533c-2.56,0-5.973,0-8.533,0.853c21.333,4.267,38.4,29.013,38.4,58.88 s-17.067,54.613-38.4,58.88c2.56,0,5.973,0.853,8.533,0.853c33.28,0,59.733-26.453,59.733-59.733S288.28,7.533,255,7.533"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M289.133,67.267c0,33.28-21.333,59.733-46.933,59.733s-46.933-26.453-46.933-59.733 S216.6,7.533,242.2,7.533S289.133,33.987,289.133,67.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15A143"
    },
    d: "M442.733,195.267c-2.56,0-5.973,0-8.533,0.853c21.333,4.267,38.4,29.013,38.4,58.88 s-17.067,54.613-38.4,58.88c2.56,0,5.973,0.853,8.533,0.853c33.28,0,59.733-26.453,59.733-59.733S476.013,195.267,442.733,195.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1CD759"
    },
    d: "M476.867,255c0,33.28-21.333,59.733-46.933,59.733S383,288.28,383,255s21.333-59.733,46.933-59.733 S476.867,221.72,476.867,255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9808"
    },
    d: "M255,383c-2.56,0-5.973,0-8.533,0.853c21.333,4.267,38.4,29.013,38.4,58.88 s-17.067,54.613-38.4,58.88c2.56,0,5.973,0.853,8.533,0.853c33.28,0,59.733-26.453,59.733-59.733S288.28,383,255,383"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD09"
    },
    d: "M289.133,442.733c0,33.28-21.333,59.733-46.933,59.733s-46.933-26.453-46.933-59.733 S216.6,383,242.2,383S289.133,409.453,289.133,442.733"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.4,255c0-29.867,17.067-54.613,38.4-58.88c-2.56-0.853-5.973-0.853-8.533-0.853 c-33.28,0-59.733,26.453-59.733,59.733s26.453,59.733,59.733,59.733c2.56,0,5.973,0,8.533-0.853 C54.467,309.613,37.4,284.867,37.4,255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54C9FD"
    },
    d: "M127,255c0,33.28-21.333,59.733-46.933,59.733S33.133,288.28,33.133,255 s21.333-59.733,46.933-59.733S127,221.72,127,255"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255,135.533c-37.547,0-68.267-30.72-68.267-68.267S217.453-1,255-1s68.267,30.72,68.267,68.267 S292.547,135.533,255,135.533z M255,16.067c-28.16,0-51.2,23.04-51.2,51.2s23.04,51.2,51.2,51.2s51.2-23.04,51.2-51.2 S283.16,16.067,255,16.067z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255,511c-37.547,0-68.267-30.72-68.267-68.267s30.72-68.267,68.267-68.267s68.267,30.72,68.267,68.267 S292.547,511,255,511z M255,391.533c-28.16,0-51.2,23.04-51.2,51.2c0,28.16,23.04,51.2,51.2,51.2s51.2-23.04,51.2-51.2 C306.2,414.573,283.16,391.533,255,391.533z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.267,323.267C29.72,323.267-1,292.547-1,255s30.72-68.267,68.267-68.267s68.267,30.72,68.267,68.267 S104.813,323.267,67.267,323.267z M67.267,203.8c-28.16,0-51.2,23.04-51.2,51.2s23.04,51.2,51.2,51.2s51.2-23.04,51.2-51.2 S95.427,203.8,67.267,203.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M442.733,323.267c-37.547,0-68.267-30.72-68.267-68.267s30.72-68.267,68.267-68.267S511,217.453,511,255 S480.28,323.267,442.733,323.267z M442.733,203.8c-28.16,0-51.2,23.04-51.2,51.2s23.04,51.2,51.2,51.2 c28.16,0,51.2-23.04,51.2-51.2S470.893,203.8,442.733,203.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.128,
    y: 143.786,
    transform: "matrix(-0.7349 0.6782 -0.6782 -0.7349 361.1906 163.4446)",
    width: 151.043,
    height: 17.067
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 286.455,
    y: 348.614,
    transform: "matrix(-0.7344 0.6787 -0.6787 -0.7344 870.2097 373.7651)",
    width: 151.038,
    height: 17.066
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123.587,
    y: 246.467,
    width: 259.413,
    height: 17.067
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.afa0a5ba6e7385484c72d3cb04c19bcf.svg";
export { ForwardRef as ReactComponent };